export default "__VITE_ASSET__Bcr9z7VH__"